export default "__VITE_ASSET__D_ah7A0h__"